import {
  LayoutOptions,
  PrimaryCollectionBlockType,
  processLayoutOptions,
} from "@kameleon-core/lib";
import { InferProps } from "prop-types";

enum MediaPlacement {
  left = "left",
  right = "right",
}

export const layoutOptions = {
  ...LayoutOptions.BackgroundColor,
  ...{
    mediaPlacement: LayoutOptions.Options(MediaPlacement),
  },
};

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

export type ContentCollectionType = {
  /** Place prop documentation here */
} & PrimaryCollectionBlockType<LayoutProps>;
